import React, { ReactNode } from 'react';
import { Dialog } from '@headlessui/react';
import { AutoTradeModelEnum } from 'views/Accounts/types';
import { CloseBlackIcon } from 'assets/icons';

interface IAutoTradeModelProps {
  open: boolean;
  onClose: () => void;
  isDisabled?: boolean;
  config: {
    id?: AutoTradeModelEnum;
    buttonSection?: ReactNode;
    titleSection?: ReactNode;
    textSection?: ReactNode;
    onClose?: () => void;
  };
}

const AutoTradeModel = ({ open, onClose, config, isDisabled }: IAutoTradeModelProps) => {
  return (
    <Dialog as="div" className="relative z-10" open={open} onClose={() => {}}>
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

      <div className="fixed inset-0 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4 text-center">
          <Dialog.Panel className="w-full max-w-2xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
            <div className="flex flex-1 flex-row justify-end">
              <CloseBlackIcon
                onClick={() => {
                  if (isDisabled) return;
                  onClose();
                }}
                className="w-[12px] cursor-pointer mb-2"
              />
            </div>
            <Dialog.Title className="font-medium leading-6 text-gray-900">{config?.titleSection}</Dialog.Title>
            {config?.textSection}
            {config?.buttonSection}
          </Dialog.Panel>
        </div>
      </div>
    </Dialog>
  );
};

export default AutoTradeModel;
